import React, { useState } from "react";
import { useDrop } from "react-dnd";
import Tippy from "@tippyjs/react";
import Xarrow, { Xwrapper, useXarrow } from "react-xarrows";
import { useLoading, Rings } from "@agney/react-loading";
import { delete_step, get_metadata_info } from "./Api";
import Modal from "./Modal_Components/Modal";
import { useEffect } from "react";
import Link from "./Link";
import Drop_Action_Node from "./Drop_action";
import Action_Node from "./Action_Node";

export function Content() {
  const { containerProps, indicatorEl } = useLoading({
    loading: true,
    indicator: <Rings width="100" />,
  });

  return <section {...containerProps}>{indicatorEl}</section>;
}

const Conditional_node = (props) => {

  const updateXarrow = useXarrow();

  var childs = props.workflow_graph_data.get(props.action_data);


  var targeta = childs.filter((child) => {
    return props.action_data.targetA == child.id;
  });
  var targetb = childs.filter((child) => {
    return props.action_data.targetB == child.id;
  });



  const getchildren = (root) => {

    var children = props.workflow_graph_data.get(root);
    if (children.length == 0) {
      return (
        <>
          <ul>
            <li>
              <Drop_Action_Node
                id={"drop_action" + root.id}
                name="Add an Action"
                path="Yes"
                modal_props={props.modal_props}
                conditional_node={true}
                add_step={props.add_step}
                source_id={root.id}
              ></Drop_Action_Node>
            </li>
          </ul>

          <Link start={root.id} end={"drop_action" + root.id} dashness={true}></Link>
        </>
      );
    }
    return children.map((child) => {
      if (child.metadata.splitFlag == true) {
        //Conditional Node
        return (
          <ul>
            <li>
              <Conditional_node
                add_step={props.add_step}
                modal_props={props.modal_props}
                handle_loading={props.handle_loading}
                handlestepsResponse={props.handlestepsResponse}
                workflow_graph_data={props.workflow_graph_data}
                action_data={child}
              ></Conditional_node>
            </li>
          </ul>
        );
      } else if (child.metadata.splitFlag == false) {
        //Action Node
        return (
          <>
            <ul>
              <Action_Node
                name={child.metadata.name}
                id={child.id}
                action_data={child}
                handlestepsResponse={props.handlestepsResponse}
                handle_loading={props.handle_loading}
                add_step={props.add_step}
                modal_props={props.modal_props}
              ></Action_Node>
            </ul>

            {getchildren(child)}
          </>
        );
      }
    });
  };

  return (
    <>
      <Action_Node
        name={props.action_data.metadata.name}
        id={props.action_data.id}
        handlestepsResponse={props.handlestepsResponse}
        handle_loading={props.handle_loading}
        add_step={props.add_step}
        action_data={props.action_data}
        modal_props={props.modal_props}
      ></Action_Node>
      <ul>
        {props.action_data.targetA == null ? (
          <li>
            <Drop_Action_Node
              id={"ifelse_yes" + props.action_data.id}
              path="yes"
              name="Yes"
              conditional_node={true}
              source_id={props.action_data.id}
              modal_props={props.modal_props}
              add_step={props.add_step}
            ></Drop_Action_Node>
          </li>
        ) : (
          <>
            <li>
              {targeta[0].metadata.splitFlag == true ? (
                <Conditional_node
                  add_step={props.add_step}
                  modal_props={props.modal_props}
                  handle_loading={props.handle_loading}
                  handlestepsResponse={props.handlestepsResponse}
                  workflow_graph_data={props.workflow_graph_data}
                  action_data={targeta[0]}
                ></Conditional_node>
              ) : (
                <>
                  <ul>
                    <li>
                      <Action_Node
                        name={targeta[0].metadata.name}
                        id={targeta[0].id}
                        action_data={targeta[0]}
                        handlestepsResponse={props.handlestepsResponse}
                        handle_loading={props.handle_loading}
                        add_step={props.add_step}
                        modal_props={props.modal_props}
                      ></Action_Node>
                    </li>
                  </ul>

                  {getchildren(targeta[0])}
                </>
              )}
            </li>
          </>
        )}

        {props.action_data.targetB == null ? (
          <li>
            <Drop_Action_Node
              id={"ifelse_no" + props.action_data.id}
              name="No"
              path="no"
              conditional_node={true}
              modal_props={props.modal_props}
              source_id={props.action_data.id}
              add_step={props.add_step}
            ></Drop_Action_Node>
          </li>
        ) : (
          <>
            <li>
              {targetb[0].metadata.splitFlag == true ? (
                <Conditional_node
                  add_step={props.add_step}
                  modal_props={props.modal_props}
                  handle_loading={props.handle_loading}
                  handlestepsResponse={props.handlestepsResponse}
                  workflow_graph_data={props.workflow_graph_data}
                  action_data={targetb[0]}
                ></Conditional_node>
              ) : (
                <>
                  <ul>
                    <li>
                      <Action_Node
                        name={targetb[0].metadata.name}
                        id={targetb[0].id}
                        action_data={targetb[0]}
                        handlestepsResponse={props.handlestepsResponse}
                        handle_loading={props.handle_loading}
                        add_step={props.add_step}
                        modal_props={props.modal_props}
                      ></Action_Node>
                    </li>
                  </ul>

                  {getchildren(targetb[0])}
                </>
              )}
            </li>
          </>
        )}
      </ul>

      {props.action_data.targetA == null ? (
        <Link
          start={props.action_data.id}
          end={"ifelse_yes" + props.action_data.id}
          dashness={true}
          label="Yes"
        ></Link>
      ) : (
        ""
      )}
      {props.action_data.targetB == null ? (
        <Link
          start={props.action_data.id}
          end={"ifelse_no" + props.action_data.id}
          dashness={true}
          label="No"
        ></Link>
      ) : (
        ""
      )}
    </>
  );
};

export default Conditional_node;
